import { Component, Vue, Prop} from "vue-property-decorator";
import http from "@/services/Http";
import { KlarnaCheckoutWidget } from "@/models/KlarnaCheckout";
import { KlarnaCheckoutApi } from "@/models/KlarnaCheckout";
import { EventBus } from "@/events";

@Component
export default class PaymentMethod extends Vue {
    protected forceKlarnaRerender: boolean = false;
    private url: string = window.location.origin + window.location.pathname;

    constructor() {
        super();
    }

    protected mounted() {
        this.getKlarnaCheckout();

        EventBus.$on("refreshCartSummary", (variantId: string) => {
            this.getKlarnaCheckout();
        });
    }

    protected getKlarnaCheckout() {
        http.get<KlarnaCheckoutWidget>(`${this.url}.GetKlarnaCheckout`)
        .then(r => {
            if (window._klarnaCheckout && !this.forceKlarnaRerender) {
                window._klarnaCheckout((api: KlarnaCheckoutApi) => {
                    api.resume();
                });
            } else {
                $("#klarna-widget").append(r.widget);
                $("#klarna-widget")[0].scrollIntoView();
                if (this.forceKlarnaRerender) {
                    this.forceKlarnaRerender = false;
                }
            }
        });
    }
}
